<template>
    <div class="footer-wrap">
        <div class="footerInfo">
            Copyright © 2020 www.expo-museums.com 中博协市场推广专委会 版权所有
            电子邮箱： info@chinampr.org <br />
            备案号：京ICP备10003390号-4 京公网安备 11010502031432号 <br />
            网站建设：易拍全球科技（北京）有限公司
        </div>
        <div class="footerCode">
            <img src="../assets/001.png" alt="" />
            <img src="../assets/002.png" alt="" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.footer-wrap {
    width: 100%;
    height: 200px;
    background: #373737;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    .footerInfo {
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
    }
    .footerCode{
        margin-left: 75px;
        img{
            max-width: 100px;
            margin-left: 30px;
        }
    }
}
</style>